/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = require('react');
var throttle = _interopDefault(require('lodash.throttle'));

var defaultOptions = {
  leading: false,
  trailing: true
};

var useThrottledFn = function useThrottledFn(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;
  var dependencies = arguments.length > 3 ? arguments[3] : undefined;
  var throttled = throttle(fn, wait, options);
  return react.useCallback(throttled, dependencies);
};

exports.default = useThrottledFn;
